import { jsxs as j, jsx as r } from "react/jsx-runtime";
import i from "clsx";
import { useContext as z, useRef as M, useLayoutEffect as V } from "react";
import { C as k, a2 as q, a3 as h, m as K, F as U, u as J, af as Q, S as X, G as S } from "./helpers-458d7e27.js";
import { a as Y } from "./TextGroup-dd19925e.js";
import { c as a, e as Z, d as ee, a as f, g as te, F as se, b as ae, f as oe } from "./FeatureColumnItem-4bc31ce0.js";
import { jsx as T, css as v } from "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
import "./TruncatedTextGroup-9d089bba.js";
import "./JumpLinkNavGradient-43d260a5.js";
const re = "FeatureGraphicSection", F = new k(re), ie = ({
  headlineAlignment: e = "Headline Left",
  graphicImage: t,
  graphicColorTop: o,
  graphicVersionTop: s = "GraphicRightCurveSmall",
  theme: m
}) => {
  const c = i(
    F.getComponentClassName(),
    F.getPropsValueClassName("headlineAlignment", e)
  ), l = e === "Headline Right" && "SplitLeftSmall", p = e === "Headline Right", n = !!(t != null && t.baseImage), u = () => p && n && /* @__PURE__ */ T(
    K,
    {
      ...t,
      css: v`
          position: absolute;
          left: 0;
          top: 0;
          height: ${m === "compact" ? "30%" : "50%"};
          width: 50%;
          z-index: 0.5;
          background: var(--color-primary);
          aspect-ratio: 16 / 9;
        `
    }
  );
  return /* @__PURE__ */ T(
    q,
    {
      graphicVersion: l || s,
      graphicColor: o,
      className: c,
      css: v`
        --height: 150vw;
        --min-height: unset;
        --image: 100%;
        display: none;
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 0;

        &.feature-graphic-section {
          overflow: visible;
        }

        @media (min-width: ${h.lg}) {
          display: flex;
          --height: 50vw;
          --min-height: 36rem;
          --image: 100%;
        }

        @media (min-width: ${h.xl}) {
          --height: 45vw;
          --min-height: 51.6rem;
        }

        @media (min-width: ${h["2xl"]}) {
          --height: 60rem;
          --min-height: 67.4rem;
        }
      `,
      renderBackgroundImage: n ? () => u() : void 0
    }
  );
};
const ne = "8vw", me = "6vw", ce = "4vw", le = "6vw", pe = (e) => e === "compact" ? me : ne, ue = (e, t, o) => {
  const s = pe(t);
  return e ? s : o || s;
}, ge = (e) => e === "compact" ? le : ce, de = (e, t) => t || ge(e), Ce = ({
  className: e,
  headline: t,
  headlineAlignment: o = "Headline Left",
  collection: s = [],
  bottomSpacer: m = "4vw",
  graphicImage: c,
  theme: l = "white",
  graphicVersionTop: p,
  graphicColorTop: n = "GoldOnWhite",
  graphicVersionBottom: u,
  graphicColorBottom: P,
  isAnimated: x = !0,
  componentId: _,
  disclosureType: I,
  topSpacer: O,
  hideGraphicShapes: g = !1
}) => {
  const { foundationGrid: d } = z(U), C = M(null), { viewportType: N } = J();
  Q(50);
  const w = !!t, y = i(
    e,
    a.getComponentClassName(),
    g && a.getElementClassName("no-graphic-shape")
  ), L = ae(o);
  V(() => {
    C.current && Z({
      length: s.length,
      viewportType: N,
      elRef: C.current
    });
  });
  const E = {
    topSpacing: ue(w, d, O),
    bottomSpacing: de(d, m),
    rowsGap: "value",
    rowsGapValue: "0vw"
  }, H = {
    minWidth: "6rem",
    minHeight: "6rem"
  }, R = oe(
    g,
    u,
    P
  );
  return /* @__PURE__ */ j(
    X,
    {
      ref: C,
      className: y,
      options: E,
      theme: l,
      id: _,
      disclosure: I,
      disclosureGridItemProps: ee,
      ...R,
      children: [
        t && /* @__PURE__ */ r(
          S,
          {
            className: i(
              a.getElementClassName("col"),
              a.getElementClassName("startCol")
            ),
            ...L.startCol,
            children: /* @__PURE__ */ r(Y, { ...t, analyticsCompName: f })
          }
        ),
        x && t && !g && /* @__PURE__ */ r(
          ie,
          {
            headlineAlignment: o,
            graphicImage: c,
            graphicVersionTop: p,
            graphicColorTop: n,
            theme: d
          }
        ),
        s && s.map(({ pictogram: $, feature: b, truncatedTextGroup: D }, G) => {
          const { gridItemProps: B, isLastRow: W } = te(
            G,
            s.length,
            w,
            N
          ), A = i(
            a.getElementClassName("col"),
            a.getElementClassName("itemCol"),
            { [a.getElementClassName("with-padding")]: !W }
          );
          return /* @__PURE__ */ r(
            S,
            {
              className: A,
              ...B,
              children: /* @__PURE__ */ r(
                se,
                {
                  dimensions: H,
                  pictogram: $,
                  feature: b,
                  truncatedTextGroup: D,
                  className: i(a.getElementClassName("Item")),
                  analyticsCompName: f
                }
              )
            },
            `item-${G + 1}`
          );
        })
      ]
    }
  );
};
Ce.displayName = f;
export {
  Ce as default
};
//# sourceMappingURL=FeatureColumnType.js.map
